import { makeStyles, createStyles, alpha, Theme } from '@material-ui/core';

interface StyleProps {
  active?: boolean;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: 0,
      minWidth: 160,
      color: theme.palette.primary.main,
    },
    inputLabelSelect: {
      transform: 'translate(14px, 11px) scale(1)',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
    select: {
      height: 24.5,
      '&:focus': {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
      },
    },
    selectBrands: {
      backgroundColor: ({ active }: StyleProps) =>
        active
          ? alpha(theme.palette.primary.main, 0.15)
          : theme.palette.common.white,
      color: theme.palette.primary.main,
      transition: 'background-color 250ms',
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.3),
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-focused:hover .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline':
        {
          borderColor: theme.palette.primary.main,
          borderWidth: 1,
        },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: alpha(theme.palette.primary.main, 0.5),
        borderWidth: 1,
      },
      '& > div': {
        borderColor: theme.palette.primary.main,
        padding: '6px 32px 6px 16px !important',
        fontSize: theme.typography.pxToRem(13),
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: 'normal',
        color: `${theme.palette.primary.main} !important`,
      },
    },
    icon: {
      color: `${theme.palette.primary.main} !important`,
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
  }),
);
